// @flow

import React from 'react'
import styled, { css } from 'styled-components'

const NotFound = styled.div`
  line-height: 1.5;
`

export default () => {
  return (
    <NotFound>
      スペースが見つかりませんでした。
      <br />
      検索条件を変更し、もう一度検索してください。
    </NotFound>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/room/RoomNotFound/index.jsx